module.exports = __webpack_public_path__ + "img/WETH.78927583.svg";